<div class="resource-form">
    <div>
        <form #resourceForm="ngForm">
            <div>
                <label class="resource-field-label">{{'report_estimated_budget_for_execution' | translate }}</label>
                <input required #estimated_budget="ngModel" [(ngModel)]="Resource.estimated_budget"
                    name="estimated_budget" required placeholder="{{'aed'|translate}}" type="number"
                    class="surface-overlay w-12" pInputText />
                @if((estimated_budget.invalid &&
                !estimated_budget.pristine)||(isResourcSubmitted&&estimated_budget.invalid)){
                <div>
                    <span class="text-red-500">
                        {{'field_is_required'|translate}}
                    </span>
                </div>
                }
            </div>
            <div class="mt-3">
                <label class="resource-field-label">{{'supporter_sponsor_participation' | translate}}</label>
                <input required #sponsor_engagement="ngModel" [(ngModel)]="Resource.sponsor_engagement"
                    name="sponsor_engagement" required placeholder="{{'aed'|translate}}" type="number"
                    class="surface-overlay w-12" pInputText />
                @if((sponsor_engagement.invalid &&
                !sponsor_engagement.pristine)||(isResourcSubmitted&&sponsor_engagement.invalid)){
                <div>
                    <span class="text-red-500">
                        {{'field_is_required'|translate}}
                    </span>
                </div>
                }
            </div>
            <div class="mt-3">
                <label class="resource-field-label">{{'internally_required_resources' | translate}}</label>
                <div>
                    <textarea pInputTextarea required [(ngModel)]="Resource.required_internal_resources"
                        name="required_internal_resources" #required_internal_resources="ngModel" placeholder=""
                        rows="3" cols="30" pInputTextarea>
                    </textarea>
                    @if((required_internal_resources.invalid &&
                    !required_internal_resources.pristine)||(isResourcSubmitted&&required_internal_resources.invalid)){
                    <div>
                        <span class="text-red-500">
                            {{'field_is_required'|translate}}
                        </span>
                    </div>
                    }
                </div>
            </div>
            <div class="mt-3">
                <label class="resource-field-label">{{'externally_required_resources' | translate}}</label>
                <div>
                    <textarea required [(ngModel)]="Resource.required_external_resources"
                        #required_external_resources="ngModel" name="required_external_resources" placeholder=""
                        rows="3" cols="30" pInputTextarea>
                    </textarea>
                    @if((required_external_resources.invalid &&
                    !required_external_resources.pristine)||(isResourcSubmitted&&required_external_resources.invalid)){
                    <div>
                        <span class="text-red-500">
                            {{'field_is_required'|translate}}
                        </span>
                    </div>
                    }
                </div>
            </div>
            <div class="mt-3">
                <label class="resource-field-label">{{'resource_optimization_methodology_in_initiative_implementation' | translate}}</label>
                <div>
                    <textarea required #rationalization_method="ngModel" [(ngModel)]="Resource.rationalization_method"
                        name="rationalization_method" rows="3" cols="30" pInputTextarea>
                    </textarea>
                    @if((rationalization_method.invalid &&
                    !rationalization_method.pristine)||(isResourcSubmitted&&rationalization_method.invalid)){
                    <div>
                        <span class="text-red-500">
                            {{'field_is_required'|translate}}
                        </span>
                    </div>
                    }
                </div>
            </div>

        </form>
        <div>

            <div class="flex justify-content-between mt-5">
                <div class="g-c-primaryDarkerColor font-bold">{{'Items' | translate}}</div>
                <div>
                    <p-button (onClick)="isVisiblBudgetItemModal=true" label="{{'add_item' | translate}}"
                        [outlined]="true" />
                </div>
            </div>
        </div>
        <div class="mt-5">
            <p-table [class]="dir" [value]="Resource['budget_items']" [paginator]="true" [rows]="5"
                [rowsPerPageOptions]="[5, 10, 20]" [tableStyle]="{ 'min-width': '50rem' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            {{'item' | translate}}
                            <p-sortIcon [field]=""></p-sortIcon>
                        </th>
                        <th>
                            {{'amount' | translate}}
                            <p-sortIcon [field]=""></p-sortIcon>
                        </th>
                        <th>
                            {{'description' | translate}}
                            <p-sortIcon [field]=""></p-sortIcon>
                        </th>
                        <th>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    @if(!item.is_deleted){
                    <tr>

                        <td>
                            {{item['name']}}
                        </td>
                        <td>
                            {{item['value'] | currency:'AED'}}
                        </td>
                        <td>
                            {{item['description']}}
                        </td>

                        <td>
                            <div class="flex justify-content-evenly align-items-center">
                                <div tooltipPosition="top" [pTooltip]="updateBudgetItemsToolTip" showDelay="500"
                                    hideDelay="300" (click)="openUpdatBudgetItemeModal(rowIndex)"
                                    class="update__icon cursor-pointer">
                                    <svg width="27" height="27" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.4768 3.004C16.6438 3.019 16.7168 3.223 16.5968 3.342L8.27682 11.662C8.18283 11.756 8.11553 11.8734 8.08182 12.002L7.08182 15.832C7.04881 15.9586 7.04948 16.0916 7.08375 16.2178C7.11803 16.344 7.18472 16.4591 7.27721 16.5516C7.36971 16.6441 7.48478 16.7108 7.61101 16.7451C7.73725 16.7793 7.87025 16.78 7.99682 16.747L11.8258 15.747C11.9545 15.713 12.0719 15.6453 12.1658 15.551L20.6038 7.113C20.6302 7.0859 20.6638 7.06693 20.7007 7.05833C20.7375 7.04974 20.7761 7.05188 20.8117 7.06451C20.8474 7.07713 20.8787 7.09971 20.9019 7.12957C20.9252 7.15943 20.9394 7.19532 20.9428 7.233C21.2939 10.5826 21.2738 13.9608 20.8828 17.306C20.6598 19.211 19.1288 20.706 17.2308 20.919C13.7545 21.3044 10.2462 21.3044 6.76982 20.919C4.87082 20.706 3.33982 19.211 3.11682 17.306C2.70455 13.781 2.70455 10.22 3.11682 6.695C3.33982 4.789 4.87082 3.294 6.76982 3.082C9.99434 2.72466 13.247 2.69852 16.4768 3.004Z"
                                            fill="#0A9B4D" />
                                        <path
                                            d="M17.8231 4.237C17.8463 4.21372 17.8739 4.19525 17.9043 4.18264C17.9347 4.17004 17.9672 4.16355 18.0001 4.16355C18.033 4.16355 18.0656 4.17004 18.0959 4.18264C18.1263 4.19525 18.1539 4.21372 18.1771 4.237L19.5911 5.652C19.6378 5.69886 19.6641 5.76233 19.6641 5.8285C19.6641 5.89467 19.6378 5.95814 19.5911 6.005L11.2981 14.3C11.2665 14.3313 11.2272 14.3537 11.1841 14.365L9.27012 14.865C9.22793 14.876 9.1836 14.8758 9.14152 14.8644C9.09944 14.8529 9.06109 14.8307 9.03025 14.7999C8.99942 14.769 8.97719 14.7307 8.96577 14.6886C8.95434 14.6465 8.95412 14.6022 8.96512 14.56L9.46512 12.646C9.47625 12.6029 9.49869 12.5635 9.53012 12.532L17.8231 4.237Z"
                                            fill="#0A9B4D" />
                                    </svg>
                                </div>

                                <div (click)="confirmBudgetItemsDelete($event,rowIndex)"
                                    [pTooltip]="deleteBudgetItemsToolTip" tooltipPosition="left" showDelay="500"
                                    hideDelay="300"
                                    class="text-red-600 text-2xl flex   cursor-pointer text-lg font-bold ">
                                    <i class="fa-regular fa-trash-can"></i>

                                </div>
                            </div>

                        </td>

                    </tr>
                    }

                </ng-template>
            </p-table>
        </div>




    </div>
</div>
@if(isVisiblBudgetItemModal)
{
<div class="g-modal">
    <div class="flex  justify-content-between align-items-center flex-row-reverse ">
        <div (click)="closeBudgetItemModal()"
            class="bg-red-500 g-c-white cursor-pointer  w-3rem p-1 shadow-4 text-center  font-bold text-xl  bg-secondary-color border-round">
            <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="titel font-bold g-c-primaryDarkerColor g-c-primaryDarkerColor">
            {{'add_item' | translate}}
        </div>
    </div>
    <div class="br">
    </div>
    <div class="modal__body">
        <form #budget_itemForm="ngForm" (ngSubmit)="submitBudget_itemForm()">
            <div class="mt-3">
                <div class="mb-2 g-c-primaryDarkColor font-bold">
                    <label>{{'name' | translate}}</label>
                </div>
                <input [(ngModel)]="selected_budget_item.name" #name="ngModel" name="name" required type="text"
                    class="surface-overlay w-12" pInputText />

                @if((name.invalid &&
                !name.pristine)||(isBudgetItemFormSubmitted&&name.invalid))

                {
                <div>
                    <span class="text-red-500">
                        {{'field_is_required'|translate}}

                    </span>
                </div>
                }
            </div>
            <div class="mt-3">
                <div class="mb-2 g-c-primaryDarkColor font-bold">
                    <label>{{'amount' | translate}}</label>
                </div>
                <input [(ngModel)]="selected_budget_item.value" #value="ngModel" name="value" required type="number"
                    class="surface-overlay w-12" pInputText />
                @if((value.invalid &&
                !value.pristine)||(isBudgetItemFormSubmitted&&value.invalid))

                {
                <div>
                    <span class="text-red-500">
                        {{'field_is_required'|translate}}
                    </span>
                </div>
                }
            </div>
            <div class="mt-3">
                <div class="mb-3 g-c-primaryDarkColor font-bold">
                    <label>{{'description' | translate}}</label>
                </div>
                <textarea required [(ngModel)]="selected_budget_item.description" #description="ngModel"
                    name="description" rows="5" cols="30" pInputTextarea>
                                    </textarea>
                @if((description.invalid &&
                !description.pristine)||(isBudgetItemFormSubmitted&&description.invalid))

                {
                <div>
                    <span class="text-red-500">
                        {{'field_is_required'|translate}}
                    </span>
                </div>
                }
            </div>
            <div class="mt-4">
                <p-button label="{{'save' | translate}}" [raised]="true" type="submit" />
            </div>
        </form>
    </div>
</div>
<div class="g-overlay"></div>
}

<ng-template #deleteBudgetItemsToolTip>
    <div class="flex align-items-center">
        <span>{{'remove_item' | translate}}</span>
    </div>
</ng-template>

<ng-template #updateBudgetItemsToolTip>
    <div class="flex align-items-center">
        <span> {{'edit_item' | translate}}</span>
    </div>
</ng-template>

<p-confirmPopup #confirmPopupRef>
    <ng-template pTemplate="headless" let-message let-test>
        <div class="border-round p-3">
            <span>{{ message.message }}</span>
            <div class="flex align-items-center gap-2 mt-3">
                <p-button i18n-label (click)="accept()" i18n-label label="{{'yes'|translate}}"
                    severity="danger"></p-button>
                <p-button i18n-label (click)="reject()" i18n-label label="{{'no'|translate}}"
                    severity="secondary"></p-button>
            </div>
        </div>
    </ng-template>
</p-confirmPopup>